var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticClass:"card-img-top audio-funny-img",attrs:{"src":_vm.thumburl.replace('.resized.{bucket}', '')}}),_vm._v(" "),_c('audio',{staticClass:"audio-controls-funny",attrs:{"controls":""}},[_c('source',{attrs:{"src":_vm.audiourl}})])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ee3fb82","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/previews/SingleFunnyVoice.vue
// module id = 403
// module chunks = 1